import PropTypes from 'prop-types'
import React from 'react'

const IconFlag = ({ active }) => (
  <>
    {active ? (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="34"
        height="34"
        viewBox="0 0 34 34"
        fill="none"
      >
        <path
          d="M9.5 2.5L5.5 5.5V21.5L9.5 19.5H12.5L17 21.5L20.5 23H24.5L28.5 21.5V5.5H23.5H18L14.5 2.5H9.5Z"
          fill="#F24405"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.34949 2.14893C7.43122 1.71624 9.03958 1.33331 11.3337 1.33331C13.7489 1.33331 15.7497 2.13391 17.4747 2.82416C17.5023 2.83522 17.5299 2.84626 17.5574 2.85726C19.3554 3.57646 20.8709 4.16665 22.667 4.16665C24.6229 4.16665 25.8479 3.84124 26.537 3.5656C26.8829 3.42725 27.1007 3.29872 27.2138 3.22326C27.2667 3.18805 27.2975 3.16384 27.3087 3.15478C27.7372 2.75357 28.3625 2.63834 28.9077 2.86416C29.4682 3.09633 29.8337 3.64329 29.8337 4.24998V21.25C29.8337 21.6478 29.6756 22.0293 29.3943 22.3106L28.3337 21.25C29.3943 22.3106 29.3935 22.3114 29.3927 22.3122L29.3911 22.3138L29.3878 22.3171L29.3807 22.3241L29.3648 22.3395C29.3534 22.3503 29.3404 22.3625 29.3257 22.3758C29.2964 22.4024 29.2607 22.4336 29.218 22.4687C29.1327 22.539 29.0203 22.6245 28.8779 22.7194C28.5927 22.9096 28.1907 23.1352 27.6512 23.351C26.5694 23.7837 24.9611 24.1666 22.667 24.1666C20.2518 24.1666 18.251 23.366 16.526 22.6758C16.4983 22.6647 16.4708 22.6537 16.4432 22.6427C14.6453 21.9235 13.1297 21.3333 11.3337 21.3333C9.37773 21.3333 8.15276 21.6587 7.46366 21.9344C7.11778 22.0727 6.9 22.2012 6.7868 22.2767C6.73399 22.3119 6.70312 22.3361 6.69195 22.3452C6.26341 22.7464 5.63814 22.8616 5.09297 22.6358C4.53246 22.4036 4.16699 21.8567 4.16699 21.25V4.24998C4.16699 3.85215 4.32503 3.47062 4.60633 3.18932L5.66699 4.24998C4.60633 3.18932 4.60711 3.18854 4.6079 3.18775L4.60951 3.18615L4.61284 3.18285L4.61993 3.17589L4.63587 3.1605C4.64729 3.14961 4.66029 3.13747 4.67493 3.12416C4.70421 3.09755 4.73998 3.06631 4.7826 3.03121C4.8679 2.96097 4.98035 2.87545 5.1227 2.78055C5.40795 2.59039 5.80995 2.36475 6.34949 2.14893ZM7.16699 5.06428V18.8666C8.1946 18.5625 9.55894 18.3333 11.3337 18.3333C13.7489 18.3333 15.7497 19.1339 17.4747 19.8242L17.5574 19.8573C19.3554 20.5765 20.8709 21.1666 22.667 21.1666C24.6229 21.1666 25.8479 20.8412 26.537 20.5656C26.6491 20.5208 26.7477 20.477 26.8337 20.4357V6.63338C25.806 6.93748 24.4417 7.16665 22.667 7.16665C20.2517 7.16665 18.251 6.36604 16.526 5.6758C16.4983 5.66473 16.4707 5.6537 16.4432 5.64269C14.6453 4.9235 13.1297 4.33331 11.3337 4.33331C9.37773 4.33331 8.15276 4.65872 7.46366 4.93436C7.35159 4.97919 7.25297 5.02299 7.16699 5.06428ZM27.2745 3.18778C27.276 3.18628 27.2776 3.18478 27.2791 3.18329L27.279 3.18337L27.276 3.18628"
          fill="#F24405"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.66699 19.75C6.49542 19.75 7.16699 20.4216 7.16699 21.25V31.1667C7.16699 31.9951 6.49542 32.6667 5.66699 32.6667C4.83857 32.6667 4.16699 31.9951 4.16699 31.1667V21.25C4.16699 20.4216 4.83857 19.75 5.66699 19.75Z"
          fill="#F24405"
        />
      </svg>
    ) : (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="27"
        height="32"
        viewBox="0 0 27 32"
        fill="none"
      >
        <path
          d="M2 20.2499C2 20.2499 3.41667 18.8332 7.66667 18.8332C11.9167 18.8332 14.75 21.6666 19 21.6666C23.25 21.6666 24.6667 20.2499 24.6667 20.2499V3.24992C24.6667 3.24992 23.25 4.66659 19 4.66659C14.75 4.66659 11.9167 1.83325 7.66667 1.83325C3.41667 1.83325 2 3.24992 2 3.24992V20.2499Z"
          stroke="#444243"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 30.1667V20.25"
          stroke="#444243"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )}
  </>
)

IconFlag.propTypes = {
  active: PropTypes.bool.isRequired,
}

export default IconFlag
